import { render } from "./template-libraries.vue?vue&type=template&id=d3adf3a4"
import script from "./template-libraries.vue?vue&type=script&lang=js"
export * from "./template-libraries.vue?vue&type=script&lang=js"

import "./template-libraries.vue?vue&type=style&index=0&id=d3adf3a4&lang=postcss"
script.render = render

export default script